export default "__VITE_ASSET__BAcDDh98__"